import { LOCALES } from "@marketplace/i18n";
import { personlaProfileFormI18n, partnerProfileFormI18n,clientCredentialsFormI18n} from "./components";
export const personalPageI18n = {
    [LOCALES.ENG]: {
        developer_personal_page_my_account: 'My Account',
        developer_personal_page_personal_profile: "Personal Profile",
        developer_personal_page_client_credentials: "Client Credentials",
        developer_personal_page_partner_profile: 'Partner Profile',
        developer_personal_page_sub_logo: 'Developer Portal',
        developer_personal_page_cancel: 'Cancel',
        developer_personal_page_save: 'Save',
        ...personlaProfileFormI18n[LOCALES.ENG],
        ...clientCredentialsFormI18n[LOCALES.ENG],
        ...partnerProfileFormI18n[LOCALES.ENG]
    }
}